import { Data } from '../../actions/data.action';
import { Info } from '../../actions/info.action';
import { Observable } from 'rxjs/Observable';

export class ClinicModel {
  public currentBookingOptions: any = null; // current data of widget
  public widgetIdForRouting: string = null; // widget id
  public indexOfChosenClinic: number = null;

  constructor(currentBookingOptions: any, widgetIdForRouting: string) {
    this.currentBookingOptions = currentBookingOptions;
    this.widgetIdForRouting = widgetIdForRouting;
  }
}
// model of store and subscribtions
export class ClinicStoreModel {
  public info$: Observable<Info>;
  public model$: Observable<Data>;
  public subscribtion$: any;
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/clinic/clinic.model.ts